import { createSlice } from "@reduxjs/toolkit";
import { ContactUsSubmitApi } from "../api/ContactUsApi";

const initialState = {
  contactData: {},
  successMessage: null,
  loading: false,
  error: null,
};

const ContactUsSlice = createSlice({
  name: "ContactUsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(ContactUsSubmitApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(ContactUsSubmitApi.fulfilled, (state, action) => {
        state.loading = false;
        state.contactData = action.payload.data;
        state.successMessage = action.payload.message;
      })
      .addCase(ContactUsSubmitApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default ContactUsSlice.reducer;
